import type { VehicleExpirationStatus } from '@/modules/vehicles'
import type { DateRange } from 'react-day-picker'

/**
 * The filters shared by the fleet-wide vehicle lists (documents, expiration
 * dates, services). Pages that need more add their own fields on top of this.
 */
export interface VehicleListFilterForm {
  /** Free-text search, sent to the backend as `q`. */
  q: string
  vehicles: string[]
  responsibleUsers: string[]
  /**
   * Empty string means "any status". Only the lists whose rows carry an
   * expiration date offer it — a service has a booking status of its own.
   */
  expirationStatus: VehicleExpirationStatus | ''
  /**
   * The date the row is about: the expiry deadline on documents and
   * expirations, the scheduled slot on services. Each page maps it to its own
   * query variables.
   */
  dateRange: DateRange | null
}

export const emptyVehicleListFilter: VehicleListFilterForm = {
  q: '',
  vehicles: [],
  responsibleUsers: [],
  expirationStatus: '',
  dateRange: null,
}
